import React from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const BlogPage = () => {

  const blogs = [
    {
      id: 1,
      title: 'What is AI?',
      description: 'Explore the future of Artificial Intelligence and its potential to change the world. Here, we present you a comprehensive and a unique take on AI.',
      image: 'WhatIsAI.jpg',
      slug: '/blog/what-is-ai',
      type: 'blog',
      readTime: '5 min read',
      date: '25 July, 2024'
    },
    {
      id: 3,
      title: 'SyntheticDataFest 2024',
      description: 'October is almost here, and it brings the Hacktoberfest with it. This year, we plan to host our very own version of this event - SyntheticDataFest.',
      image: 'MainImage.jpg',
      slug: '/blog/synthetic-data-fest',
      type: 'blog',
      readTime: '3 min read',
      date: '10 October, 2024'
    },
    {
      id: 2,
      title: 'AI & Synthetic Data',
      description: 'Synthetic Data is gaining more and more prominence. In this blog, we answer the questions What is Synthetic Data and How is it used?',
      image: 'SmallerSyntheticDataPicture.jpg',
      slug: '/blog/synthetic-data-ai',
      type: 'blog',
      readTime: '4 min read',
      date: '15 December, 2024'
    },
    {
      id: 4,
      title: 'Data Quality for Large Language Models',
      description: 'Learn the different quality criteria for datasets used to train and finetune AI models.',
      image: 'DataQuality.jpg',
      slug: '/blog/data-quality-llms',
      type: 'blog',
      readTime: '5 min read',
      date: '05 January, 2025'
    },
    {
      id: 5,
      title: 'AI Applications in Education',
      description: 'Synthetic Data and AI systems in general are changing the way Students learn and Teachers teach. Explore more in this detailed blog.',
      image: 'AI_Education.jpg',
      slug: '/blog/synthetic-data-education',
      type: 'blog',
      readTime: '7 min read',
      date: '28 December, 2024'
    },
    {
      id: 6,
      title: '7 Ways Synthetic Data helps NLP Applications',
      description: 'This blog describes NLP usecases and enumerates how Synthetic Data helps NLP usecases like Classification, Summarization and so on.',
      image: 'AreasofNLP.jpg',
      slug: '/blog/synthetic-data-nlp',
      type: 'blog',
      readTime: '6 min read',
      date: '18 November, 2025'
    },
    {
      id: 7,
      title: 'RAG for Synthetic Data',
      image: 'RAG.jpg',
      description: 'Synthetic Data and RAG Aren\'t Opposites. Here\'s How They Actually Work Together.',
      slug: '/blog/rag-for-synthetic-data',
      type: 'blog',
      readTime: '6 min read',
      date: '15 December, 2025'
    },
    {
      id: 8,
      title: 'Synthetic Data vs Web Scraping',
      description: 'Why can\'t I just scrape data from the web? Here\'s why you shouldn\'t.',
      image: 'SyntheticvsWeb.jpg',
      slug: '/blog/synthetic-data-vs-web-scraping',
      type: 'blog',
      readTime: '5 min read',
      date: '22 December, 2025'
    },
    {
      id: 9,
      title: 'Public Data Sources vs DataCreator AI',
      description: 'Solving different Data Problems in different ways. Read to know more.',
      image: 'PublicVsDataCreatorAI.jpg',
      slug: '/blog/datacreator-ai-vs-public-data-repositories',
      type: 'blog',
      readTime: '5 min read',
      date: '30 December, 2025'
    },
    {
      id: 11,
      title: 'Introduction to FineTuning',
      description: 'Why fine-tuning is cheaper, faster, and more consistent at scale.',
      image: 'FineTuning.jpg',
      slug: '/blog/intro-fine-tuning',
      type: 'blog',
      readTime: '5 min read',
      date: '01 January, 2026'
    },
    {
      id: 10,
      title: 'DataCreator AI Software Development Kit',
      description: 'Generate multi-turn conversations for training and evaluation workflows.',
      image: 'SDK_Initial.png',
      slug: '/blog/datacreator-ai-sdk-beta',
      type: 'blog',
      readTime: '5 min read',
      date: '05 January, 2026'
    },
    {
      id: 11,
      title: 'Fine-tuning GPT with Synthetic Data - A Case Study',
      description: 'A practical case study on fine-tuning GPT using synthetic data to build AI models that guide students with hints instead of direct answers.',
      image: 'Thumbnail_AI_Education.jpg',
      slug: '/blog/fine-tuning-gpt',
      type: 'blog',
      readTime: '5 min read',
      date: '15 January, 2026'
    },
    {
      id: 12,
      title: 'Synthetic Data for Evals: Testing Devstral 2 in the Real World',
      description: 'Learn how to use synthetic data to create evaluation datasets for testing coding models like Mistral AI\'s Devstral 2 with human-in-the-loop evaluations.',
      image: 'Evals_Mistral.jpg',
      slug: '/blog/synthetic-data-evals',
      type: 'blog',
      readTime: '8 min read',
      date: '01 February, 2026'
    },
    {
      id: 13,
      title: 'Student Ambassador Program',
      description: 'We believe that students are the architects of the future. Join us in shaping the world of AI, one dataset at a time.',
      image: 'COP_Image.png',
      slug: '/blog/student-ambassador-program',
      type: 'blog',
      readTime: '4 min read',
      date: '07 February, 2026'
    },
    {
      id: 14,
      title: 'How to fine-tune AI Models Without Buying a GPU',
      description: 'A curated list of the best free and paid options available today to fine-tune AI models.',
      image: 'FineTuningOptions.jpg',
      slug: '/blog/practical-guide-fine-tuning',
      type: 'blog',
      readTime: '8 min read',
      date: '13 March, 2026'
    },
    {
      id: 15,
      title: 'Introducing Custom Orders',
      description: 'Need datasets beyond standard limits? Learn how Custom Orders let you get expert-crafted, cleaned, and tailored datasets delivered to your specifications.',
      image: 'CustomOrder.jpg',
      slug: '/blog/custom-orders',
      type: 'blog',
      readTime: '6 min read',
      date: '28 March, 2026'
    },
    {
      id: 16,
      title: 'Why Now is the Best Time to Build Your Own Local AI Models',
      description: 'Explore why the "API Era" might be shifting, the hidden costs of subsidized intelligence, and how local models can give you end-to-end control over your pipeline.',
      image: 'LocalModels.png',
      slug: '/blog/build-local-models',
      type: 'blog',
      readTime: '3 min read',
      date: '14 April, 2026'
    },
    {
      id: 17,
      title: 'Will models run out of data?',
      description: 'Stanford\'s AI Index 2026 warns that high-quality training data may run out by 2032. Here is what that means for the future of AI and why synthetic data is now at the center of it all.',
      image: 'AIIndexReport.png',
      slug: '/blog/synthetic-data-future-ai-index',
      type: 'blog',
      readTime: '7 min read',
      date: '16 April, 2026'
    },
    {
      id: 18,
      title: 'What is JSONL and Why Every AI Dataset Uses It',
      description: 'JSONL is quietly the most important file format in AI. Here is what it is, why fine-tuning APIs demand it, and how DataCreator AI generates it for you automatically.',
      image: 'JSONL.png',
      slug: '/blog/what-is-jsonl',
      type: 'blog',
      readTime: '3 min read',
      date: '17 April, 2026'
    }
  ];

  const filteredBlogs = [...blogs].reverse();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 font-sans selection:bg-blue-500/30 relative">

      {/* Decorative Background Elements - aligned with LandingPage style */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50 opacity-80 dark:opacity-10" />
      </div>

      <div className="relative container mx-auto px-6 md:px-12 lg:px-24 pt-8 pb-16">

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <AnimatePresence mode='popLayout'>
            {filteredBlogs.length > 0 ? (
              filteredBlogs.map((blog, index) => (
                <motion.div
                  key={blog.id}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                  className="group relative flex flex-col h-full bg-white dark:bg-gray-900 rounded-2xl overflow-hidden border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-2xl transition-all duration-500"
                >
                  <Link to={blog.slug} className="block overflow-hidden aspect-video relative">
                    <div className="absolute inset-0 bg-gray-900/10 group-hover:bg-transparent transition-colors z-10" />
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out"
                      onError={(e) => {
                        // Fallback logic could be improved, keeping existing simpler fallback approach
                        e.target.src = 'logo192.png';
                      }}
                    />
                  </Link>

                  <div className="flex flex-col flex-grow p-6 md:p-8">
                    <div className="flex items-center space-x-2 mb-4">
                      <span className="text-xs font-bold font-mono tracking-widest text-blue-600 dark:text-blue-400 uppercase bg-blue-50 dark:bg-blue-900/20 px-2 py-1 rounded-md">
                        {blog.type}
                      </span>
                      {blog.readTime && (
                        <span className="text-xs text-gray-400 dark:text-gray-500 font-medium">
                          • {blog.readTime}
                        </span>
                      )}
                      {blog.date && (
                        <span className="text-xs text-gray-400 dark:text-gray-500 font-medium">
                          • {blog.date}
                        </span>
                      )}
                    </div>

                    <Link to={blog.slug}>
                      <h2 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-300 leading-tight">
                        {blog.title}
                      </h2>
                    </Link>

                    <p className="text-gray-600 dark:text-gray-400 mb-6 line-clamp-3 text-sm md:text-base leading-relaxed">
                      {blog.description}
                    </p>

                    <div className="mt-auto pt-4 border-t border-gray-100 dark:border-gray-800 flex items-center justify-between">
                      <Link
                        to={blog.slug}
                        className="inline-flex items-center text-sm font-semibold text-gray-900 dark:text-white group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors"
                      >
                        Read Article
                        <svg className="w-4 h-4 ml-1 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </motion.div>
              ))
            ) : (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="col-span-full py-20 text-center"
              >
                <div className="inline-block p-4 rounded-full bg-gray-100 dark:bg-gray-800 mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /></svg>
                </div>
                <h3 className="text-xl font-medium text-gray-900 dark:text-white mb-2">Coming Soon</h3>
                <p className="text-gray-500 dark:text-gray-400">Our research papers are being curated. Check back later!</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
